import api from '../token';

export const AddComentario = async (payload) => {
  try {
    const response = await api.post('/addComentario',payload);
    return response.data;
  } catch (error) {
   
    return [];
  }
};

